/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const router = {
  path: '/guanghe',
  component: Layout,
  children: [{
    path: 'index/:Id',
    name: 'guanghe',
    meta: {
      title: "详情"
    },
    component: () =>
      import('@/views/guanghe/index.vue')
  },{
    path: 'details/:Id',
    name: 'guanghe',
    meta: {
      title: "详情"
    },
    component: () =>
      import('@/views/guanghe/details.vue')
  },
  {
    path: 'lesseeDetails/:Id',
    name: 'guanghe',
    meta: {
      title: "详情"
    },
    component: () =>
      import('@/views/guanghe/lesseeDetails.vue')
  },
   {
    path: 'detail/:Id',
    name: 'detail',
    meta: {
      title: "服务详情"
    },
    component: () =>
      import('@/views/guanghe/detail.vue')
  }, {
    path: '/guanghe/bianmin',
    name: 'bianmin',
    meta: {
      title: "便民事宜"
    },
    component: () =>
      import('@/views/guanghe/bianmin.vue')
  }, {
    path: '/guanghe/newAdd',
    name: 'newAdd',
    meta: {
      title: "闲置资产出租"
    },
    component: () =>
      import('@/views/guanghe/newAdd.vue')
  },
  {
    path: '/addhouse',
    name: 'addhouse',
    meta: {
      title: '新增房源',
    },
    component: () => import('@/views/guanghe/addhouse.vue'),
  },
  {
    path: '/guanghe/RoomList/:leaseId',
    name: 'RoomList',
    meta: {
      title: '便民食堂',
    },
    component: () => import('@/views/guanghe/RoomList.vue'),
  },
  // {
  //     path: '/guanghe/brief',
  //     name: 'brief',
  //     meta: {
  //         title: "晔光小站简介"
  //     },
  //     component: () =>
  //         import ('@/views/guanghe/brief.vue')
  // }, 
  {
    path: '/guanghe/evaluating',
    name: 'evaluating',
    meta: {
      title: "闲置资产出租"
    },
    component: () =>
      import('@/views/guanghe/evaluating.vue')
  }, {
    path: '/guanghe/zhiyuan',
    name: 'zhiyuan',
    meta: {
      title: "志愿活动"
    },
    component: () =>
      import('@/views/guanghe/zhiyuan.vue')
  },
  {
    path: '/guanghe/addXianzhi',
    name: 'addXianzhi',
    meta: {
      title: "闲置资产新增"
    },
    component: () =>
      import('@/views/guanghe/addXianzhi.vue')
  },
  ]
}

export default router